import React from 'react';
import './floatContacto.css';
import { ErrorBarra } from 'errores';
import { FloatingMenu, MainButton, ChildButton } from 'react-floating-button-menu';
import { ReactComponent as TwitterAudi } from './imgs/audi/twitter-large.svg';
import { ReactComponent as NotepadAudi } from './imgs/audi/notepad-large.svg';
import { ReactComponent as MailAudi } from './imgs/audi/mail_icono.svg';
import { ReactComponent as LlamadaAudi } from './imgs/audi/llamada_icono.svg';
import { ReactComponent as FacebookAudi } from './imgs/audi/facebook-large.svg';
import { ReactComponent as CerrarAudi } from './imgs/audi/cerrar_icono.svg';

import { ReactComponent as CerrarVW } from './imgs/vw/cerrar_ico.svg';
//import { ReactComponent as FacebookVW } from './imgs/vw/facebook_ico.svg';
import { ReactComponent as LlamadaVW } from './imgs/vw/llamada_ico.svg';
import { ReactComponent as MailVW } from './imgs/vw/mail_ico.svg';
//import { ReactComponent as TwitterVW } from './imgs/vw/twitter_ico.svg';
import { ReactComponent as AbrirVW } from './imgs/vw/abrir_ico.svg';

import { ReactComponent as CerrarSeat } from './imgs/seat/close_ico.svg';
import { ReactComponent as FacebookSeat } from './imgs/seat/facebook_ico.svg';
import { ReactComponent as LlamadaSeat } from './imgs/seat/ico_phone.svg';
import { ReactComponent as MailSeat } from './imgs/seat/contact.svg';
import { ReactComponent as MasSeat } from './imgs/seat/plus_ico.svg';
import { ReactComponent as TwitterSeat } from './imgs/seat/twitter_ico.svg';

export default class FloatContacto extends React.Component {

    tiwtterName = "";
    facebookName = "";
    templateMail = "kmi_concesionaria_contacto_";
    constructor(props) {
        super(props);
        this.onSendMail = this.onSendMail.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.state = { mensajeCounter: 0, errorlabelAutorizacion: false, errorlabelMensaje: false, errorlabel: false, errorMensaje: "", asuntoMail: "", mensajeMail: "", autorizacionMail: false, showModalMail: false, showModalMailSended: false, isOpen: false, mailIcon: <div></div>, callIcon: <div></div>, masIcon: <div></div>, closeIcon: <div></div>, facebookIcon: <div></div>, twitterIcon: <div></div>, classNameMainButton: '', classNameSubButton: '', dealerJson: { correo: null, telefono: null }, dealer2: {} };
        this.cerrarError.bind(this);
    }

    componentWillMount() {
        window.removeEventListener("resize", this.updateWindowDimensions);
    }

    updateWindowDimensions = () => {
        let widthActual = (window.innerWidth >= 768);
        this.setState({ isOpen: widthActual });
    }

    componentDidMount() {
        this.init();
        this.setState({ isOpen: (window.innerWidth >= 768) });
        window.addEventListener("resize", this.updateWindowDimensions);
        if (this.props.marca !== process.env.REACT_APP_MARCA_VW) {
            this.props.servicioFirebase.registrarVistaVisitadaAnalitica("FloatContacto");
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.numConcesionaria !== prevProps.numConcesionaria) {
            this.init();
        }
    }

    createSubButtonVW(Component, text) {
        return <div className="sub-button--vw__row"><Component /><span className="sub-button__text--vw">{text}</span></div>
    }

    init = () => {
        if (this.props.numConcesionaria !== undefined && this.props.numConcesionaria !== null && this.props.numConcesionaria !== "") {
            fetch(process.env.REACT_APP_URL_DTO_GLOBAL + 'concesionaria?numConcesionaria=' + this.props.numConcesionaria, {
                method: 'GET',
                headers: {
                    "Authorization": "Bearer " + this.props.servicio.getToken()
                }
            }).then(async res => {
                try {
                    let responseBody = await res.json();
                    if (res.status < 299 && Array.isArray(responseBody.mensaje)) {
                        let concesionaria = responseBody.mensaje[0];
                        this.setState(prevState => {
                            let dealerJson = Object.assign({}, prevState.dealerJson);
                            dealerJson.correo = concesionaria.correo;
                            dealerJson.telefono = concesionaria.telefono;
                            return { dealerJson };
                        })
                    } else {
                        this.setState({ error: true, errorMensaje: "¡Ups! Algo ha pasado, favor de reintentar." });
                    }
                } catch (err) {
                    console.error(err);
                }
            })
                .catch(error => {
                    console.log(error)
                });
            switch (this.props.marca) {
                case "vw":
                    /*this.tiwtterName = 'Volkswagen_MX';
                    this.facebookName = 'VolkswagenMX';*/
                    this.templateMail += '1';
                    this.setState({
                        mailIcon: this.createSubButtonVW(MailVW, 'Contáctanos'),
                        callIcon: this.createSubButtonVW(LlamadaVW, 'Llámanos'),
                        masIcon: <AbrirVW />,
                        closeIcon: <CerrarVW />,
                        /*facebookIcon: this.createSubButtonVW(FacebookVW, 'Facebook'),
                        twitterIcon: this.createSubButtonVW(TwitterVW, 'Twitter'),*/
                        classNameMainButton: 'main-button--vw',
                        classNameSubButton: 'sub-button--vw',
                        classNameAButton: 'a-button--vw'
                    });
                    break;
                case "audi":
                    this.tiwtterName = 'AudideMexico';
                    this.facebookName = 'AudideMexico'
                    this.templateMail += '4';
                    this.setState({
                        mailIcon: <MailAudi />,
                        callIcon: <LlamadaAudi />,
                        masIcon: <NotepadAudi />,
                        closeIcon: <CerrarAudi />,
                        facebookIcon: <FacebookAudi />,
                        twitterIcon: <TwitterAudi />,
                        classNameMainButton: 'main-button--audi',
                        classNameSubButton: 'sub-button--audi',
                        classNameAButton: 'a-button--audi'
                    });
                    break;
                case "seat":
                    this.tiwtterName = 'SEAT_Mexico';
                    this.facebookName = 'SEAT.Mexico';
                    this.templateMail += '3';
                    this.setState({
                        mailIcon: <MailSeat />,
                        callIcon: <LlamadaSeat />,
                        masIcon: <MasSeat />,
                        closeIcon: <CerrarSeat />,
                        facebookIcon: <FacebookSeat />,
                        twitterIcon: <TwitterSeat />,
                        classNameMainButton: 'main-button--seat',
                        classNameSubButton: 'sub-button--seat',
                        classNameAButton: 'a-button--seat'
                    });
                    break;
                default:
                    break
            }
        }
    }

    onSendMail = async (event) => {
        let correo = this.props.servicio.getInfoUsuario().correo;
        if (correo === "") {
            this.setState({ errorMensaje: 'Verifica que tu sesión siga activa. Actualiza la página.' });
            return;
        }
        if (this.state.asuntoMail.trim() === "") {
            this.setState({ errorlabel: true });
            return;
        }
        if (this.state.mensajeMail.trim() === "") {
            this.setState({ errorlabelMensaje: true });
            return;
        }
        if (this.props.marca !== process.env.REACT_APP_MARCA_VW) {
            this.props.servicioFirebase.registrarEventoPersonalizadoAnalitica("action-enviar-contactanos", { marca: this.props.marca, descripcion: "Enviar asunto y mensaje en contactanos" });
        }
        this.setState({ cargando: true });

        fetch(process.env.REACT_APP_URL_DTO_BACK + 'enviamail', { //Todo ver si esto corresponde a carpeta de enviaMail
            method: 'post',
            headers: {
                "Authorization": "Bearer " + this.props.servicio.getToken()
            },
            body: JSON.stringify({ correo: this.state.dealerJson.correo, template: this.templateMail, substitutions: { asunto: [this.state.asuntoMail], mensaje: [this.state.mensajeMail], correo: [correo] } })
        }).then(response => {
            return response.json()
        }).then(json => {
            if (json.message === "OK")
                this.setState({ cargando: false, errorlabelAutorizacion: false, asuntoMail: "", mensajeMail: "", errorMensaje: "", errorlabelMensaje: false, errorlabel: false, autorizacionMail: true, showModalMail: false, showModalMailSended: true, mensajeCounter: 0 });
            else
                this.setState({ cargando: false, errorMensaje: "Error al enviar tus dudas. Inténtalo nuevamente." });
            return;
        })
            .catch(error => {
                if (this.props.marca !== process.env.REACT_APP_MARCA_VW) {
                    this.props.servicioFirebase.registrarErrorAnalitica(error, false);
                }
                this.setState({ cargando: false, errorMensaje: "Error al enviar tus dudas. Inténtalo nuevamente." });
            });



        event.preventDefault();
    }
    openTwitter = () => {
        window.open('https://twitter.com/intent/tweet?original_referer=&ref_src=twsrc%5Etfw&screen_name=' + this.tiwtterName + '&tw_p=tweetbutton');
    }
    openFacebook = () => {
        window.open('https://www.facebook.com/' + this.facebookName + '/');
    }
    closeModal = () => {
        if (this.props.marca !== process.env.REACT_APP_MARCA_VW) {
            this.props.servicioFirebase.registrarEventoPersonalizadoAnalitica("action-close-modal-contactanos", { marca: this.props.marca, descripcion: "Cierre de ventana modal de contáctanos" });
        }
        this.setState({ errorlabelAutorizacion: false, asuntoMail: "", mensajeMail: "", showModalMail: false, errorMensaje: "", errorlabelMensaje: false, errorlabel: false, mensajeCounter: 0, autorizacionMail: true })
    }
    onClickMail = () => {
        if (this.props.marca !== process.env.REACT_APP_MARCA_VW) {
            this.props.servicioFirebase.registrarEventoPersonalizadoAnalitica("action-contactanos", { marca: this.props.marca, descripcion: "Opción Contactanos en menu flotante" });
        }
        this.setState({ showModalMail: true });
    }
    onClickPhone = () => {
        if (this.props.marca !== process.env.REACT_APP_MARCA_VW) {
            this.props.servicioFirebase.registrarEventoPersonalizadoAnalitica("action-llamanos", { marca: this.props.marca, descripcion: "Opcion Llamanos en menu flotante" });
        }
        window.open('tel:' + this.state.dealerJson.telefono);
    }

    handleChange(event) {
        if (event.target.id === "autorizacion") {
            this.setState({ autorizacionMail: event.target.checked, errorlabelAutorizacion: false });
        }
    }

    cerrarError() {
        this.setState({ errorMensaje: "" });
    }

    render() {
        var cerrarError = this.cerrarError;
        return (
            this.props.numConcesionaria !== undefined && this.props.numConcesionaria !== null && (this.state.dealerJson.correo !== null || this.state.dealerJson.telefono !== null) ?
                <div>{this.props.marca === "vw" ?
                    <div>
                        <FloatingMenu
                            className={this.props.marca === 'vw' ? "float-button--vw float-button" : "float-button"}
                            slideSpeed={500}
                            direction="up"
                            spacing={8}
                            onClick={() => {
                                if (this.props.marca !== process.env.REACT_APP_MARCA_VW) {
                                    this.props.servicioFirebase.registrarEventoPersonalizadoAnalitica("action-float-button", { marca: this.props.marca, descripcion: "Opciones de menu flotante" });
                                }
                            }}
                            isOpen={this.state.isOpen}>

                            <MainButton
                                iconResting={this.state.masIcon}
                                iconActive={this.state.closeIcon}
                                onClick={() => this.setState({ isOpen: !this.state.isOpen })}
                                size={55}
                                className={this.state.classNameMainButton}
                            />
                            {/*<ChildButton
                            icon={this.state.facebookIcon}
                            size={40}
                            onClick={this.openFacebook}
                            className={this.state.isOpen ? this.state.classNameSubButton : "sub-button--hide"}
                        />
                        <ChildButton
                            icon={this.state.twitterIcon}
                            size={40}
                            onClick={this.openTwitter}
                            className={this.state.isOpen ? this.state.classNameSubButton : "sub-button--hide"}
                        />*/}
                            <ChildButton
                                icon={this.state.mailIcon}
                                size={40}
                                className={(this.state.dealerJson.correo !== null && this.state.isOpen ? this.state.classNameSubButton : "sub-button--hide")}
                                onClick={() => { this.onClickMail() }}
                            />
                            <ChildButton
                                icon={this.state.callIcon}
                                className={(this.state.dealerJson.telefono !== null && this.state.isOpen ? this.state.classNameSubButton : "sub-button--hide")}
                                size={40}
                                onClick={() => this.onClickPhone()}
                            />

                        </FloatingMenu>
                    </div >
                    :
                    <div className="container">
                        <div className="col col-md-8 offset-md-2 mb-3 text-left">
                            <div className="row">
                                <div className="col-12">
                                    <p className="contacto-concesionaria__title">Contacta al Concesionario</p>
                                </div>
                            </div>
                            <div className="row contacto-concesionaria__options">
                                <div className={"col-sm-12 col-md-6 cursor-pointer contacto-concesionaria__option contacto-concesionaria__option--" + this.props.marca} onClick={() => this.onClickPhone()}>{this.state.callIcon}<span className="contacto-concesionaria__option--margin">Llámanos</span></div>
                                <div className={"col-sm-12 col-md-6 cursor-pointer contacto-concesionaria__option contacto-concesionaria__option--" + this.props.marca} onClick={() => this.onClickMail()}>{this.state.mailIcon}<span className="contacto-concesionaria__option--margin">Escríbenos</span></div>
                            </div>
                        </div>
                    </div>
                }
                    <div className={"modal fade show " + (this.state.showModalMail ? " d-block" : "d-none") + " form__modal container__font--" + this.props.marca} id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog--lg modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button type="button" className={"form__close-button--" + this.props.marca} aria-label="Close" onClick={this.closeModal}>
                                        <svg width="48" height="48" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                            <title>
                                                cancel-large
                                            </title>
                                            <path d="M31.6,15.4 L15.4,31.6 M15.4,15.4 L31.7,31.7" stroke="currentColor" strokeWidth="1" fill="none" fillRule="evenodd" />
                                        </svg>
                                    </button>
                                </div>
                                <div className="modal-body modal-body--padding">
                                    <div className={this.state.errorMensaje !== "" ? "d-block" : "d-none"}>
                                        <ErrorBarra mensaje={this.state.errorMensaje} marca={this.props.marca} cerrarError={cerrarError.bind(this)} />
                                    </div>
                                    <h4>Escribe a tu concesionaria</h4>
                                    <p style={{ marginBottom: '30px' }}>Si tienes dudas en tu proceso con gusto te asesoramos.</p>
                                    {this.props.marca === 'vw' && <small><label className="form__bluefont--vw">Nos interesa conocer tu opinión.</label></small>}
                                    <input placeholder='Asunto' value={this.state.asuntoMail} onChange={(change) => this.setState({ asuntoMail: change.target.value, errorlabel: false })} type="text" className={"w-100 form-control form-control-lg form__input--" + this.props.marca + (this.state.errorlabel ? " form__input--" + this.props.marca + "-error" : "")} maxLength="40" />
                                    <span className={this.state.errorlabel ? "form__errorlabel--" + this.props.marca : "d-none"}>* Ingrese un asunto</span>
                                    <br></br>

                                    <div className="form-group">
                                        <textarea placeholder='Mensaje' value={this.state.mensajeMail} onChange={(change) => this.setState({ mensajeMail: change.target.value, errorlabelMensaje: false, mensajeCounter: change.target.value.trim().length })} className={"w-100 form-control form-control-lg form__input--" + this.props.marca + (this.state.errorlabelMensaje ? " form__input--" + this.props.marca + "-error" : "")} maxLength="1000" />
                                        <span className={this.state.errorlabelMensaje ? "form__errorlabel--" + this.props.marca : "d-none"}>* Ingresa tu mensaje<br /></span>
                                        {this.props.marca === "vw" && <span className="text--vw-gray"><small>{this.state.mensajeCounter}/1000 caracteres</small></span>}
                                        {this.props.marca === "seat" && <span className="text--seat-gray"><small>{this.state.mensajeCounter}/1000</small></span>}
                                        {this.props.marca === "audi" && <p style={{ marginBottom: '30px' }}>Max. 1000 caracteres</p>}
                                        <br />
                                    </div>

                                    {this.props.marca === "audi" &&
                                        <div className="row" style={{ marginTop: '5em' }}>
                                            <div className="col-10 col-sm-11">
                                                <p className={"guias__aviso--" + this.props.marca} onClick={() => {
                                                    if (this.props.marca !== process.env.REACT_APP_MARCA_VW) {
                                                        this.props.servicioFirebase.registrarEventoPersonalizadoAnalitica("action-concesionaria-guias-aviso", { marca: this.props.marca, descripcion: "Redirección a pagina de aviso y privacidad" });
                                                    }
                                                    window.open(this.props.terminosCondiciones, '_blank')
                                                }}
                                                    rel="noopener noreferrer">
                                                    Aviso de privacidad
                                                    {
                                                        this.props.marca === "seat" ? (
                                                            <svg width="8px" height="14px" viewBox="0 0 8 14" version="1.1" xmlns="http://www.w3.org/2000/svg" >
                                                                <g id="" stroke="none" strokeWidth="1" fill="none" fill-rule="evenodd">
                                                                    <g id="color" transform="translate(-164.000000, -22.000000)" fill="#0f0f0f">
                                                                        <g id="" transform="translate(24.000000, 16.000000)">
                                                                            <polygon id="" transform="translate(144.000000, 12.500000) rotate(-90.000000) translate(-144.000000, -12.500000) " points="148.971417 8.5 144.001083 13.4435897 139.029667 8.5 139.0275 8.5 137.5 10.0211876 144.001083 16.5 150.5 10.0211876 148.973583 8.5"></polygon>
                                                                        </g>
                                                                    </g>
                                                                </g>
                                                            </svg>
                                                        ) : (this.props.marca === "audi" ? (
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="13" viewBox="0 0 8 13" >
                                                                <path stroke="currentColor" strokeWidth="1px" fill="none" d="M1.5,1l5.485,5.504l-5.48,5.496"></path>
                                                            </svg>
                                                        ) : "")
                                                    }
                                                </p>
                                            </div>
                                        </div>
                                    }
                                    {this.props.marca === "vw" &&
                                        <div className="row" style={{ marginTop: '5em' }}>

                                            <div className="col-10 col-sm-11">
                                                <p className={"guias__aviso--" + this.props.marca} onClick={() => {
                                                    if (this.props.marca !== process.env.REACT_APP_MARCA_VW) {
                                                        this.props.servicioFirebase.registrarEventoPersonalizadoAnalitica("action-concesionaria-guias-aviso", { marca: this.props.marca, descripcion: "Redirección a pagina de aviso y privacidad" });
                                                    }
                                                    window.open(this.props.terminosCondiciones, '_blank')
                                                }
                                                } rel="noopener noreferrer">
                                                    Aviso de privacidad
                                                    {
                                                        this.props.marca === "seat" ? (
                                                            <svg width="8px" height="14px" viewBox="0 0 8 14" version="1.1" xmlns="http://www.w3.org/2000/svg" >
                                                                <g id="" stroke="none" strokeWidth="1" fill="none" fill-rule="evenodd">
                                                                    <g id="color" transform="translate(-164.000000, -22.000000)" fill="#0f0f0f">
                                                                        <g id="" transform="translate(24.000000, 16.000000)">
                                                                            <polygon id="" transform="translate(144.000000, 12.500000) rotate(-90.000000) translate(-144.000000, -12.500000) " points="148.971417 8.5 144.001083 13.4435897 139.029667 8.5 139.0275 8.5 137.5 10.0211876 144.001083 16.5 150.5 10.0211876 148.973583 8.5"></polygon>
                                                                        </g>
                                                                    </g>
                                                                </g>
                                                            </svg>
                                                        ) : (this.props.marca === "audi" ? (
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="13" viewBox="0 0 8 13" >
                                                                <path stroke="currentColor" strokeWidth="1px" fill="none" d="M1.5,1l5.485,5.504l-5.48,5.496"></path>
                                                            </svg>
                                                        ) : "")
                                                    }
                                                </p>
                                            </div>
                                        </div>
                                    }
                                    {this.props.marca === "seat" &&
                                        <div className="row" style={{ marginTop: '5em' }}>

                                            <div className="col-10 col-sm-11">
                                                <p className={"guias__aviso--" + this.props.marca} onClick={() => {
                                                    if (this.props.marca !== process.env.REACT_APP_MARCA_VW) {
                                                        this.props.servicioFirebase.registrarEventoPersonalizadoAnalitica("action-concesionaria-guias-aviso", { marca: this.props.marca, descripcion: "Redirección a pagina de aviso y privacidad" });
                                                    }
                                                    window.open(this.props.terminosCondiciones, '_blank')
                                                }} rel="noopener noreferrer">
                                                    Aviso de privacidad
                                                    {
                                                        this.props.marca === "seat" ? (
                                                            <svg width="8px" height="14px" viewBox="0 0 8 14" version="1.1" xmlns="http://www.w3.org/2000/svg" >
                                                                <g id="" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                                    <g id="color" transform="translate(-164.000000, -22.000000)" fill="#0f0f0f">
                                                                        <g id="" transform="translate(24.000000, 16.000000)">
                                                                            <polygon id="" transform="translate(144.000000, 12.500000) rotate(-90.000000) translate(-144.000000, -12.500000) " points="148.971417 8.5 144.001083 13.4435897 139.029667 8.5 139.0275 8.5 137.5 10.0211876 144.001083 16.5 150.5 10.0211876 148.973583 8.5"></polygon>
                                                                        </g>
                                                                    </g>
                                                                </g>
                                                            </svg>
                                                        ) : (this.props.marca === "audi" ? (
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="13" viewBox="0 0 8 13" >
                                                                <path stroke="currentColor" strokeWidth="1px" fill="none" d="M1.5,1l5.485,5.504l-5.48,5.496"></path>
                                                            </svg>
                                                        ) : "")
                                                    }
                                                </p>
                                            </div>
                                        </div>
                                    }
                                    <div className="container">
                                        {this.props.marca === "audi" &&
                                            <div className="row mt-3 mb-2">
                                                <div className="col-6 mt-3">
                                                    <button className={"w-100 form__button--" + this.props.marca + "-ghost form__button--" + this.props.marca} name="recuperar" onClick={this.closeModal}>Cancelar</button>
                                                </div>
                                                <div className="col-6 mt-3">
                                                    <button onClick={this.onSendMail} className={"w-100 form__button--" + this.props.marca + "-black form__button--" + this.props.marca}>Enviar</button>
                                                </div>
                                            </div>
                                        }
                                        {this.props.marca === "vw" &&
                                            <div className="row mt-3 mb-2">
                                                <div className="w-50 mx-auto">
                                                    <button style={{ marginTop: '30px' }} onClick={this.onSendMail} className={"w-100 form__button--" + this.props.marca + "-black form__button--" + this.props.marca}>Enviar</button>
                                                </div>
                                            </div>
                                        }
                                    </div>

                                    {this.props.marca === "seat" &&
                                        <div className="d-flex w-100 float-left">
                                            <button style={{ marginTop: '30px' }} onClick={this.onSendMail} className={"w-100 form__button--" + this.props.marca + "-black form__button--" + this.props.marca}>Enviar</button>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className={"page__cargando page__cargando--" + this.props.marca + (this.state.cargando ? " d-block" : " d-none")} />
                    </div>
                    <div className={"modal fade show " + (this.state.showModalMailSended ? " d-block" : "d-none") + " form__modal container__font--" + this.props.marca} id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button type="button" className={"form__close-button--" + this.props.marca} aria-label="Close" onClick={() => this.setState({ showModalMailSended: false })}>
                                        <svg width="48" height="48" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                            <title>
                                                cancel-large
                                            </title>
                                            <path d="M31.6,15.4 L15.4,31.6 M15.4,15.4 L31.7,31.7" stroke="currentColor" strokeWidth="1" fill="none" fillRule="evenodd" />
                                        </svg>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <h4>Escribe a tu concesionaria</h4>
                                    <p>Gracias por contactarnos.</p>
                                    <span>En breve recibirás respuesta a tu solicitud.</span></div>
                                <div className="container">
                                    <div className="row mt-3 mb-2">
                                        <div className="col-12 mt-3">
                                            <button type="button" onClick={() => this.setState({ showModalMailSended: false })} className={"w-100 form__button--" + this.props.marca + "-black form__button--" + this.props.marca}>Cerrar</button>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                :
                <div></div>

        )
    }
}